//
//
//
//

import Products from "@/components/blocks/products/Products";

export default {
  name: "RelatedProducts",
  components: {
    Products
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    productInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    requestedCollection() {
      return this.productInfo.related_collection_slug || '';
    }
  }
}
